var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9536 4.73086C17.9611 4.91776 17.9636 5.1046 17.9636 5.2915C17.9636 10.9582 13.8367 17.5 6.29003 17.5C3.97181 17.5 1.81621 16.7863 0 15.5714C0.321044 15.6054 0.647098 15.631 0.978153 15.631C2.90027 15.631 4.67061 14.9426 6.07487 13.7872C4.27952 13.7617 2.76351 12.5129 2.24067 10.8137C2.49167 10.8647 2.75015 10.8903 3.0145 10.8903C3.38725 10.8903 3.74915 10.8393 4.09605 10.7374C2.21729 10.3466 0.802208 8.61351 0.802208 6.53207C0.802208 6.50657 0.802208 6.49802 0.802208 6.48103C1.35591 6.7954 1.98965 6.99066 2.6626 7.01616C1.5602 6.24305 0.835545 4.92624 0.835545 3.43949C0.835545 2.65788 1.03734 1.91872 1.39258 1.28154C3.41559 3.88124 6.44016 5.5889 9.84992 5.76732C9.77982 5.45297 9.744 5.12172 9.744 4.79039C9.744 2.42008 11.581 0.5 13.8475 0.5C15.0275 0.5 16.0932 1.01832 16.8412 1.85089C17.7776 1.66399 18.6549 1.3072 19.4488 0.814442C19.1411 1.81694 18.4914 2.65784 17.6426 3.18458C18.4731 3.08263 19.2653 2.85342 20 2.51359C19.4488 3.37166 18.755 4.12766 17.9536 4.73086Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2eb47ba3e6183ddbee357ec63b614e55.svg";
export { ForwardRef as ReactComponent };